import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import CheckAllowedAddress from 'scenes/Auth/CheckAllowedAddress'
import CheckVerifiedEmail from 'scenes/Auth/CheckVerifiedEmail'
import ErrorBoundary from 'scenes/ErrorBoundary'
import CheckBasicKYC from 'scenes/KYC/CheckBasicKYC'

import MarketData from '../MarketData/Context'
import Modal from '../Modal'
import Notifications from '../Notifications'
import AppConfig from './AppConfig'
import AppContainer from './AppContainer'
import Bootstrap from './Bootstrap'
import PublicRoutes from './PublicRoutes/Routes'

const modalDom = document.getElementById('modal')
const notifDom = document.getElementById('notifications')

const Main = () => {
  useEffect(() => {
    performance.mark('Main:mount')
    performance.measure('Main', 'React:start', 'Main:mount')
  }, [])

  return (
    <ErrorBoundary>
      <AppConfig>
        <PublicRoutes />
        <Bootstrap>
          <MarketData>
            <CheckAllowedAddress>
              <CheckVerifiedEmail>
                <CheckBasicKYC>
                  <AppContainer />
                </CheckBasicKYC>
              </CheckVerifiedEmail>
            </CheckAllowedAddress>
          </MarketData>
        </Bootstrap>
      </AppConfig>
      {notifDom && createPortal(<Notifications />, notifDom)}
      {modalDom && createPortal(<Modal />, modalDom)}
    </ErrorBoundary>
  )
}

export default Main
